import { ConfigurationState, ConfigurationTreeNodeModel, RootState, StoreConstants } from '@/types';
import { GetterTree } from 'vuex';

export const getters: GetterTree<ConfigurationState, RootState> = {
  [StoreConstants.Configuration.Getters.ConfigurationTree](state): ConfigurationTreeNodeModel[] {
    return state.tree;
  },
  [StoreConstants.Configuration.Getters.ExpandSelectedNodeOnMount](state): boolean {
    return state.expandSelectedNodeOnMount;
  }
};
